import React from "react";
import { ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";

export const PolicyFlag = ({ label, severity = "medium", className }) => {
  const tone =
    severity === "high"
      ? "bg-rose-50 text-rose-800 border-rose-200"
      : severity === "low"
      ? "bg-slate-50 text-slate-700 border-slate-200"
      : "bg-amber-50 text-amber-900 border-amber-200";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-[11px] font-mono uppercase tracking-wider",
        tone,
        className,
      )}
      data-testid="policy-flag"
    >
      <ShieldAlert className="h-3 w-3" />
      {label}
    </span>
  );
};

export default PolicyFlag;
